import { useCallback, useEffect } from "react";
import {
  GSForm,
  GSSidePanelPage,
  useFormDataValidation,
} from "golfstatus_react_components";
import { faChevronLeft, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useMatch } from "react-router-dom";

//import scss
import "./package-details.scss";
import {
  useNotificationAction,
  useNotificationBanner,
  useNotifications,
} from "../../../../hooks/notificationHooks";
import { getPackageForm } from "../../../../forms/PackageForm";
import { useDispatch, useSelector } from "react-redux";
import {
  getTournamentPackage,
  selectPublicTournament,
  selectTournamentPackage,
  updateCurrentPackage,
  selectLoading,
} from "../../../../reducers/tournamentSlice";
import { getRouting } from "../../../../helpers/Converters";
import {
  eventBaseRoute,
  getProp,
  PACKAGE_ID,
  TOURNAMENT_ID,
} from "../../../../routes/event";

import { useTheme } from "../../../../hooks/themeHooks";
import {
  packageHasWaitlist,
  packageSoldOut,
  useCustomer,
} from "../../../../hooks/tournamentHooks";
import {
  selectRegistrationOrder,
  clearNotifications,
  addTournamentPackageToOrderThunk,
} from "../../../../reducers/registrationOrderSlice";
import { useGolfstatusNavigate } from "../../../../hooks/navigationHooks";

//Name the component
const PackageDetails = (props) => {
  const { parent } = props;

  const dispatch = useDispatch();

  const notifications = useNotifications(false).orderNotifications;

  const currentPackage = useSelector(selectTournamentPackage);
  const registrationOrder = useSelector(selectRegistrationOrder);
  const tournament = useSelector(selectPublicTournament);

  const fallbackMatch = useMatch(
    getRouting(eventBaseRoute, [TOURNAMENT_ID, "*"])
  );
  const tournamentKey = getProp(fallbackMatch.params, TOURNAMENT_ID);

  const fallbackRoute = getRouting(eventBaseRoute, [
    tournamentKey,
    parent ?? "",
  ]);
  const navigate = useGolfstatusNavigate(fallbackRoute);

  const { customer } = useCustomer();

  const loading = useSelector(selectLoading)?.filter?.(
    (t) => t === "getTournamentPackage"
  );

  const goback = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  useNotificationAction(
    "fulfilled",
    notifications,
    goback,
    "addTournamentPackageToOrderThunk"
  );

  const route = getRouting(eventBaseRoute, [
    TOURNAMENT_ID,
    "packages",
    PACKAGE_ID,
  ]);
  const sponsorshipRoute = getRouting(eventBaseRoute, [
    TOURNAMENT_ID,
    "sponsorships",
    "package",
    PACKAGE_ID,
  ]);
  const registrantsRoute = getRouting(eventBaseRoute, [
    TOURNAMENT_ID,
    "registrants",
    "package",
    PACKAGE_ID,
  ]);

  const match = useMatch(
    parent === "sponsorships"
      ? sponsorshipRoute
      : parent === "registrants"
      ? registrantsRoute
      : route
  );
  const packageID = getProp(match?.params, PACKAGE_ID);

  const [, theme, getStyle] = useTheme();

  const [context] = useFormDataValidation({
    initialValid: true,
    setData: (update) => {
      dispatch(updateCurrentPackage(update));
    },
    data: currentPackage,
  });

  context.getPackageAction = () => {
    return !packageSoldOut(tournament, currentPackage)
      ? {
          title: "Add To Cart",
          type: "no-wrap",

          buttonIcon: faPlus,
          style: { ...getStyle(theme.tertiaryContainer), flexGrow: 1 },
          onClick: (e) => {
            save();
            e?.stopPropagation?.();
          },
        }
      : {
          title: "sold out",
          type: "black pill secondary no-wrap",
        };
  };

  useEffect(() => {
    if (packageID) {
      dispatch(getTournamentPackage(packageID));
    }
    return () => {
      dispatch(updateCurrentPackage({}));
    };
  }, [dispatch, packageID]);

  const save = () => {
    const registrationOrderItem = {
      registrationOrder: {
        ...registrationOrder,
        tournament,
        registrationCustomer: customer
      },
      tournamentPackage: currentPackage,
      accessGroupMember: {id : registrationOrder?.accessGroupMemberID}
    };
    dispatch(addTournamentPackageToOrderThunk(registrationOrderItem));
  };

  const joinWaitlist = () => {
    navigate(
      getRouting(eventBaseRoute, [
        tournament?.publicUrl,
        "packages",
        `waitlist`,
      ])
    );
  };

  const getDrawerActions = () => {
    let actions = [{ name: "close", action: leftNavigation, type: "grey" }];

    if (packageHasWaitlist(tournament, currentPackage)) {
      actions.unshift({
        name: "Join Waitlist",
        action: joinWaitlist,
        type: "black",
      });
    }

    return actions;
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Package Details`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getContent = () => {
    return <GSForm formSections={getPackageForm(context)}></GSForm>;
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    //name the component tag
    <package-details>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
        loading={loading?.length > 0}
        loadingText="Loading Package..."
      ></GSSidePanelPage>
    </package-details>
  );
};

//export the new namet
export default PackageDetails;
